import { SiteViewportActionType } from './site-viewport-action-type';

export interface SetSiteViewportSelectorVisibleAction {
  visible: boolean;
  type: SiteViewportActionType.SetSelectorVisible;
}

export const setSiteViewportSelectorVisible = (
  visible: boolean = true,
): SetSiteViewportSelectorVisibleAction => ({
  visible,
  type: SiteViewportActionType.SetSelectorVisible,
});
